// extracted by mini-css-extract-plugin
export var footer = "_ln-0";
export var inherit = "_ln-1";
export var input = "_ln-2";
export var modalContent = "_ln-3";
export var quillEditor = "_ln-4";
export var subtitle = "_ln-5";